export const FIT_OUT = 'fit_out'
export const MEP = 'mechanical_electrical_plumbing'
export const PRELIMINARIES = 'preliminaries'
export const SUBSTRUCTURE = 'substructure'
export const SUPERSTRUCTURE ='superstructure'
